type DictionaryEntry = {
  i18n?: Record<string, string[]>;
  startsWith?: string[];
  endsWith?: string[];
  attr?: {
    values?: string[];
    exact?: string[];
    prefixes?: string[];
  };
};

const dictionary: Record<string, DictionaryEntry> = {
  LOGIN: {
    i18n: {
      en: ["login", "signin", "signon", "authenticate", "connect", "new session"],
      fr: ["connexion", "se connecter", "s'identifier", "authentifier", "entrer", "nouvelle session"],
      es: ["introduce", "introducir", "entrar", "iniciar sesión", "acceder", "nueva sesión"],
      de: ["anmelden", "anmeldung", "anmeldedaten", "authentifizierungs"],
      pt: ["iniciar sessão", "conectar", "entrar", "nova sessão"],
      cz: ["přihlásit"],
      nl: ["inloggen"],
    },
  },
  REGISTER: {
    i18n: {
      en: ["register", "sign up", "create account", "join", "new account", "get started"],
      fr: ["inscrire", "créer un compte", "rejoindre", "commencer", "nouveau compte", "s'inscrire"],
      es: ["registrarse", "crear cuenta", "unirse", "empezar", "nueva cuenta"],
      de: ["registrieren", "registrierung", "neues konto", "konto erstellen"],
      pt: ["registrar", "criar conta", "juntar", "começar", "nova conta"],
      it: ["crea account", "creare account", "registrati"],
    },
  },
  RECOVERY: {
    i18n: {
      en: ["help", "recover", "restore", "restoring", "reset", "trouble", "problem"],
      fr: ["aide", "récupérer", "restaurer", "réinitialiser"],
      es: ["ayuda", "recuperar", "restaurar", "restablecer"],
      de: ["hilfe", "wiederherstellen", "zurücksetzen"],
      pt: ["ajuda", "recuperar", "restaurar", "redefinir"],
    },
  },
  MULTI_STEP: {
    i18n: {
      en: ["step", "stage", "progress"],
      fr: ["étape", "progression"],
      es: ["paso", "etapa", "progreso"],
      de: ["schritt", "phase", "fortschritt"],
      pt: ["progresso"],
    },
  },
  TROUBLE: {
    i18n: {
      en: ["forgot", "problem", "issue", "trouble", "need help"],
      fr: ["oublié", "incident", "difficulté"],
      es: ["olvidado", "incidencia", "ayuda"],
      de: ["vergessen", "schwierigkeit", "hilfe"],
      pt: ["esquecido", "questão"],
    },
  },
  PASSWORD: {
    i18n: {
      en: ["password", "secret", "passphrase", "pass code", "key", "secret code"],
      fr: ["mot de passe", "clé secrète", "phrase secrète", "code secret"],
      es: ["contraseña", "clave secreta"],
      de: ["passwort", "geheimnis", "zugangscode"],
      pt: ["senha", "chave secreta", "de segurança"],
      cz: ["heslo"],
      nl: ["wachtwoord"],
    },
    attr: {
      values: ["pwd", "pw", "mdp", "pass", "fmt"],
    },
  },
  PASSWORD_OUTLIER: {
    i18n: {
      en: ["national id", "social security", "userid", "secAnswer", "answer"],
    },
  },
  USERNAME: {
    i18n: {
      en: ["username", "identifier", "identity", "screenname", "handle", "nickname"],
      fr: ["pseudo", "utilisateur", "identifiant"],
      es: ["usuario", "identificador", "usuari"],
      de: ["nutzername", "anmelde", "benutzer"],
      nl: ["gebruikersnaam"],
    },
    attr: {
      values: ["appleid", "acct", "userid", "accountid", "loginid", "loginname", "customerid"],
    },
  },
  USERNAME_OUTLIER: {
    i18n: {
      en: ["first name", "last name", "middle name", "company name", "title"],
      fr: ["prénom", "nom de famille", "titre"],
      es: ["nombre", "apellido"],
      de: ["vorname", "nachname"],
      pt: ["primeiro nome", "sobrenome"],
    },
  },
  EMAIL: {
    i18n: {
      en: ["email"],
      fr: ["courriel"],
      es: ["correo"],
      pt: ["correio"],
    },
    attr: {
      values: ["usermail"],
    },
  },
  TEL: {
    i18n: {
      en: ["telephone", "phonenumber", "mobile", "cellnumber", "cellphone"],
      fr: ["numero de tel"],
      es: ["movil", "teléfono"],
      de: ["telefon", "mobil"],
      pt: ["celular", "telefone"],
    },
  },
  CAPTCHA: {
    attr: { values: ["captcha", "recaptcha", "hcaptcha", "solve-media", "funcaptcha", "keycaptcha"] },
  },
  SUBMIT_ACTION: {
    i18n: {
      en: ["submit", "go"],
      fr: ["valider"],
      es: ["enviar"],
      de: ["senden"],
      pt: ["enviar"],
    },
  },
  CREATE_ACTION: {
    i18n: {
      en: ["new", "set", "create"],
      fr: ["nouveau", "créer"],
      es: ["nuevo", "crear"],
      de: ["neu", "erstellen"],
      pt: ["novo", "criar"],
      it: ["creare"],
    },
    endsWith: ["1", "fst"],
  },
  RESET_ACTION: {
    i18n: {
      en: ["change", "update", "reset"],
      fr: ["mettre à jour", "réinitialiser"],
      es: ["cambiar", "actualizar", "restablecer"],
      de: ["ändern", "aktualisieren", "zurücksetzen"],
      pt: ["alterar", "atualizar", "redefinir"],
    },
  },
  CONFIRM_ACTION: {
    i18n: {
      en: ["confirm", "repeat", "verify", "retype", "again"],
      fr: ["répéter", "vérifier", "saisir à nouveau"],
      es: ["repetir", "verificar", "volver a escribir"],
      de: ["bestätigen", "wiederholen", "verifizieren", "erneut eingeben"],
      pt: ["digitar novamente"],
    },
    endsWith: ["2", "bis", "snd"],
  },
  STEP_ACTION: {
    i18n: {
      en: ["continue", "next", "proceed", "accept", "back", "finish", "complete", "get started"],
      fr: ["suivant", "prochain", "précédent", "terminer"],
      es: ["continuar", "siguiente", "anterior", "finalizar"],
      de: ["weiter", "fortfahren", "abschließen", "zurück", "fertigstellen"],
      pt: ["proximo", "terminar", "completar"],
    },
  },
  REMEMBER_ACTION: {
    i18n: {
      en: ["keep", "remember", "stay"],
      fr: ["rester", "se souvenir de"],
      es: ["mantener", "recordarme"],
      de: ["angemeldet bleiben", "mich erinnern"],
      pt: ["manter me", "lembrar de mim"],
    },
  },
  SEARCH_ACTION: {
    i18n: {
      en: ["search", "query", "find"],
      fr: ["recherche"],
      es: ["buscar"],
      de: ["suche"],
      pt: [],
    },
  },
  CURRENT_VALUE: {
    i18n: {
      en: ["previous", "current", "old", "existing", "last", "before"],
      fr: ["précédent", "actuel", "ancien", "existant", "dernier"],
      es: ["anterior", "actual", "viejo", "existente", "último"],
      de: ["vorherige", "aktuelle", "alte", "bestehende", "letzte"],
      pt: ["anterior", "atual", "antigo", "existente", "último"],
    },
    attr: {
      values: ["curr", "prev"],
    },
  },
  HIDDEN: {
    attr: {
      values: ["offscreen", "move-offscreen", "sr-only", "display-none", "screen-reader-only", "a11y-hide"],
      exact: ["hidden", "is-hidden"],
    },
  },
  OAUTH: {
    attr: { values: ["apple", "facebook", "google", "twitch"] },
  },
  TOS: {
    i18n: {
      en: ["terms of", "guideline", "consent", "acknowledge", "understand", "agree", "privacy", "policy"],
      fr: ["conditions", "consentement", "accord", "confidentialité"],
      es: ["términos", "condiciones", "consentimiento", "acuerdo", "privacidad"],
      de: ["nutzungsbedingungen", "einwilligung", "zustimmung", "datenschutzrichtlinie"],
      pt: ["termos de uso", "consentimento", "acordo", "política de privacidade"],
    },
  },
  TWO_FA: {
    i18n: {
      en: ["2FA", "2step", "multi factor", "two factor", "two step", "auth code", "security code", "verification"],
      fr: ["2 étapes", "multi-facteur", "double facteur", "double étape"],
      es: ["2 pasos", "doble paso", "doble factor", "verificacion"],
      de: ["2-Schritte", "Multi-Faktor", "Zwei-Faktor", "Zwei-Schritte"],
      pt: ["2 etapas", "dois passos", "dois fatores", "multifator", "verificação"],
    },
    attr: {
      values: ["twofactor", "twostep", "challenge", "two-factor", "loginCode", "2fa", "twofa", "tfacode", "phone_verification", "approvals_code", "authentication code", "emailCode"],
      exact: ["tfa", "mfa"],
    },
  },
  AUTHENTICATOR: {
    attr: {
      values: ["authenticator", "authentication app", "generator app", "authentificateur", "Authentifikator", "Authentifizierungs-App", "Authentisierungs-App", "autenticador", "generadora", "application d'authentification"],
    },
  },
  OTP: {
    attr: { values: ["onetime", "1time", "totp", "otp", "totpPin", "otc"] },
  },
  OTP_OUTLIER: {
    i18n: {
      en: ["resend", "new code", "send"],
      fr: ["nouveau code", "envoyer"],
      es: ["reenviar", "nuevo código", "enviar"],
      de: ["neu senden", "neuer Code", "senden"],
      pt: ["reenviar", "novo código", "enviar"],
    },
    attr: {
      // MFA types which are not authenticator related
      values: ["sms", "email"],
    },
  },
  NEWSLETTER: {
    i18n: {
      en: ["newsletter", "mailing", "bulletin"],
      es: ["boletin"],
    },
    attr: {
      values: ["newsletter", "mailing-list", "email-form", "subscription"],
    },
  },
  IDENTITY_FULLNAME: {
    attr: {
      values: ["full-name", "your-name", "address-name", "address-contact", "contact-person"],
      exact: ["name"],
    },
  },
  IDENTITY_FIRSTNAME: {
    attr: { values: ["first-name", "given-name", "first-n"], exact: ["f-name"] },
  },
  IDENTITY_MIDDLENAME: {
    attr: { values: ["middle-name", "additional-name", "middle-n"], exact: ["m-name"] },
  },
  IDENTITY_LASTNAME: {
    attr: { values: ["last-name", "surname", "family-name", "family-n", "last-n"], exact: ["l-name", "s-name"] },
  },
  IDENTITY_TELEPHONE: {
    attr: {
      values: ["phone", "mobile", "telephone", "national-number", "contact-number"],
      exact: ["tel", "tel-national", "tel-local"],
    },
  },
  IDENTITY_TELEPHONE_OUTLIER: {
    attr: { values: ["prefix", "code", "country", "extension", "security"] },
  },
  IDENTITY_ADDRESS: {
    attr: {
      values: ["address-line-one", "address-line1", "address-lines", "address1", "bill-addr", "billing-addr", "mailing-addr", "preferred-address", "street-address"],
      exact: ["address", "addr", "street", "line1", "mail-addr"],
    },
  },
  IDENTITY_ADDRESS_LINES: {
    endsWith: ["line2", "line-two", "line3", "line-three"],
  },
  IDENTITY_STATE: {
    attr: {
      values: ["address-level-1", "address-state", "address-province", "state-province"],
      exact: ["state", "province", "region", "county"],
    },
  },
  IDENTITY_CITY: {
    attr: {
      values: ["address-level-2", "address-city", "address-town", "personal-city"],
      exact: ["city", "town", "locality"],
    },
  },
  IDENTITY_ZIPCODE: {
    attr: {
      values: ["zip-code", "postal-code", "post-code", "address-zip", "address-postal", "address-postal-code", "address-zip-code"],
      exact: ["zip"],
    },
  },
  IDENTITY_ORGANIZATION: {
    attr: {
      values: ["company-name", "organization", "organization-name"],
      exact: ["organization"],
    },
  },
  IDENTITY_COUNTRY: {
    attr: {
      values: ["country-name", "address-country", "address-country-name"],
      exact: ["country"],
    },
  },
  IDENTITY_COUNTRY_CODE: {
    attr: {
      values: ["country-code"],
    },
  },

  CC_PREFIX: {
    attr: {
      values: ["creditcard", "cartecredit", "credcard", "card", "payment-card", "payments-card", "vads", "stripe", "new-card", "creditDebit"],
    },
  },

  CC_NUMBER: {
    attr: {
      values: ["card-no", "card-num", "card-no", "cc-no", "cb-num", "num-carte", "numero-carte", "numero de carte", "cardnr"],
      exact: ["cc-number", "card number"],
    },
  },

  CC_OUTLIER: {
    attr: {
      values: ["logincard", "certificate", "voucher", "coupon", "promo"],
    },
  },

  CC_CVC: {
    attr: {
      values: ["cvv", "cvc", "csc", "ccv", "card-code", "card-verification", "payments-code", "payment-code"],
      exact: ["cc-csc", "cc-cvv", "cc-code", "cvn"],
    },
  },

  CC_CODE: {
    attr: {
      values: ["security code", "pincode", "cardpin"],
    },
  },

  CC_NAME: {
    attr: {
      values: ["accountholdername", "holdername", "cardname", "cardholder", "cardholdername", "nameoncard"],
      exact: ["cc-name"],
    },
  },

  CC_EXP: {
    attr: {
      values: ["card-expiration", "expiration-date", "expiration-month-year", "expiry-date", "expiry", "expiration", "card-exp"],
      exact: ["cc-exp", "cc-expiration", "expiry date"],
    },
  },

  CC_EXP_MONTH: {
    attr: {
      values: [
        "expiry-mo",
        "expiry-m",
        "expiry-mm",

        "expire-mo",
        "expire-m",
        "expire-mm",

        "expiration-mo",
        "expiration-m",
        "expiration-mm",

        "card-mo",
        "card-m",
        "card-mm",

        "exp-mo",
        "exp-m",
        "exp-mm",

        "expiry-date-field-mo",
        "expiry-date-mo",
        "expiration-date-mo",
        "expiration-date-mm",
        "m-expiration",

        "mois-exp",
        "cb-date-mo",
      ],
      exact: ["cc-exp-month", "cc-month", "cc-mm"],
    },
    endsWith: ["mm", "month", "mo"],
  },

  CC_EXP_YEAR: {
    attr: {
      values: [
        "expiry-year",
        "expiry-y",
        "expiry-yy",
        "expiry-yyyy",

        "expire-year",
        "expire-y",
        "expire-yy",
        "expire-yyyy",

        "expiration-year",
        "expiration-y",
        "expiration-yy",
        "expiration-yyyy",

        "card-year",
        "card-y",
        "card-yy",
        "card-yyyy",

        "exp-year",
        "exp-y",
        "exp-yy",
        "exp-yyyy",

        "expiry-date-field-year",
        "expiry-date-year",
        "expiration-date-year",
        "expiration-date-yy",
        "expiration-date-yyyy",
        "y-expiration",

        "annee-exp",
        "ann-exp",
        "cb-date-ann",
      ],
      exact: ["cc-exp-year", "cc-year", "cc-yr", "cc-yy"],
    },

    endsWith: ["yy", "year"],
  },

  IFRAME_FIELD: {
    attr: {
      values: ["field", "input", "control", "form", "pci", "cvv", "cvc", "security", "pbf", "stripeFrame", "expiry"],
    },
  },

  PAYMENT: {
    attr: {
      values: ["payment", "checkout", "cart", "card"],
    },
  },

  DOCUMENT: {
    attr: {
      values: ["contract", "idcard", "insurance", "licence", "license", "membership", "nationalid", "passeport", "passport", "permit", "social security", "subscription"],
    },
  },
};

export default dictionary;
